import { jsx as t } from "react/jsx-runtime";
import { T as i } from "../../../vendor--aJiswR_.js";
import '../../../assets/index42.css';const o = "_description_yi16h_1", s = {
  description: o
};
function n({ children: e }) {
  return /* @__PURE__ */ t(i, { elementType: "span", slot: "description", className: s.description, children: e });
}
export {
  n as ItemDescription
};
//# sourceMappingURL=index.js.map
